// Import Slick Slider
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';

(function ($) {
	"use strict";
    
	var TLS_Slider = function () {

    let self = this;

    this.carousel_init = function () {
      // slider per hero 
      $('[data-carousel]').each(function(){
        if($(this).hasClass('slider-cover')){
          $(this).slick({
            arrows: false,
            dots: false,
            rows: 0
          });
        }
        // slider per cart
        if($(this).hasClass('product-carousel-cart')){
          $(this).slick({
            arrows: false,
            dots: true,
            rows: 0,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
              {
                breakpoint: 400,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 740,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                },
              },
              {
                breakpoint: 1440,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6,
                },
              },
              {
                breakpoint: 1920,
                settings: {
                  slidesToShow: 8,
                  slidesToScroll: 8,
                },
              },
            ],
          });
        }
      })

      $("[data-carousel].slider-card-st-one").slick(
        {
          arrows: true,
          dots: true,
          rows: 0,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      );

      // slider per prodotti/contenuti
      $("[data-carousel]:not(.slider-cover):not(.product-carousel-cart):not(.slider-card-st-one)").slick(
        {
          arrows: true,
          dots: true,
          rows: 0,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 420,
              settings: {
                slidesToShow: 1.1,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1.2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1.5,
              },
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2.2,
              },
            },
            {
              breakpoint: 1120,
              settings: {
                slidesToShow: 3.2,
              },
            },
            {
              breakpoint: 1320,
              settings: {
                slidesToShow: 3.5,
              },
            },
            {
              breakpoint: 1580,
              settings: {
                slidesToShow: 4.2,
              },
            },
            {
              breakpoint: 1800,
              settings: {
                slidesToShow: 5,
              },
            },

            {
              breakpoint: 1920,
              settings: {
                slidesToShow: 5.2,
              },
            },
            {
              breakpoint: 2560,
              settings: {
                slidesToShow: 6,
              },
            },
          ],
        }
      );
      
      // oriento lo slider right 
      setTimeout(() => {
        var stv = 3;
        if(window.innerWidth <= 1280){
          stv = 2;
        }
        $('.product-carousel-right, .team-right-slider, .slider-right').slick('slickGoTo',($('.product-carousel-right li.product, .team-right-slider .slick-slide, .slider-right > div').length-stv));
        
      
      }, 2000);

     
    };

    this.bind = function () {
      $( document ).on('ready', self.carousel_init );	
      // aggiorno slick al reload dei filtri
      $( document ).on( 'yith-wcan-ajax-filtered', self.carousel_init );      	
		};

    this.init = function () {	
			self.bind();
		};

		this.init();

	};


  var TLS_Product_Gallery_Slider = function () {

    let self = this;

    this.carousel_init = function () {

      setTimeout(function() { 
        $('.woocommerce-product-gallery .flex-control-thumbs').slick({ 
          infinite: false, 
          slidesToShow: 4, 
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true, 
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                vertical: false,
                verticalSwiping: false,
                arrows: false,
              }
            }
          ]
        }); 
      }, 300);

    };


    this.bind = function () {
      $( document ).on( 'ready', self.carousel_init );
      // aggiorno slick al reload dei filtri
      $( document ).on( 'yith-wcan-ajax-filtered', self.carousel_init );
		};

    this.init = function () {	
			self.bind();
		};

		this.init();

	};

	(new TLS_Slider());
  (new TLS_Product_Gallery_Slider());

})( jQuery );
  